import { __assign, __rest } from "tslib";
import React from 'react';
import Theme from './DefaultMainTheme';
export function withContextCreator() {
  var defaultTheme = function (Component) {
    var DefaultTheme = /*#__PURE__*/React.forwardRef(function DefaultTheme(props, ref) {
      var innerRef = props.innerRef,
        other = __rest(props, ["innerRef"]);
      return /*#__PURE__*/React.createElement(Component, __assign({
        theme: Theme,
        ref: innerRef || ref
      }, other));
    });
    return DefaultTheme;
  };
  return defaultTheme;
}
var defaultTheme = withContextCreator();
export default defaultTheme;